// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"174":"9b827683","605":"9c889530","725":"eccf44f9"}[chunkId] + ".chunk.js";
};